import DoublePill from './DoublePill';

export default DoublePill;
